module.exports = __webpack_public_path__ + "img/security-setting.d6098339.svg";